// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Subtract-white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referance-header {
  background-color: #FCAF17;
  height: 360px;
  position: relative;
  z-index: 1;
  padding: 0px 7% 30px 6%;
}
@media screen and (min-width: 415px) {
  .referance-header {
    height: 370px;
    padding: 0px 10% 45px 10%;
  }
}
@media only screen and (min-width: 769px) {
  .referance-header {
    height: 446px;
    padding: 0px 15% 45px 15%;
  }
}
.referance-header__text {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
@media only screen and (min-width: 768px) {
  .referance-header__text {
    font-size: 36px;
    line-height: 120%;
  }
}
@media only screen and (min-width: 1440px) {
  .referance-header__text {
    font-size: 48px;
    line-height: 62px;
  }
}
.referance-header .custom-shape-divider-bottom-1689675804 {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}
.referance-header .custom-shape-divider-bottom-1689675804 svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 23px;
}
@media only screen and (min-width: 768px) {
  .referance-header .custom-shape-divider-bottom-1689675804 svg {
    height: 31px;
  }
}
@media only screen and (min-width: 1440px) {
  .referance-header .custom-shape-divider-bottom-1689675804 svg {
    height: 165px;
  }
}
.referance-header .custom-shape-divider-bottom-1689675804 .shape-fill {
  fill: #FFFFFF;
}
.referance-bg-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: cover;
  position: absolute;
  z-index: 2;
  height: 400px;
  width: 100%;
  margin-top: -176px;
}
@media screen and (max-width: 1440px) {
  .referance-bg-image {
    margin-top: -136px;
  }
}
@media screen and (max-width: 1024px) {
  .referance-bg-image {
    background-size: contain;
    margin-top: -125px;
  }
}
@media screen and (max-width: 414px) {
  .referance-bg-image {
    display: none;
  }
}
.referance-logolist {
  position: relative;
  padding: 0 30px;
  margin-top: 20px;
  margin-bottom: 36px;
  grid-template-columns: repeat(4, 1fr);
  display: grid;
}
@media only screen and (min-width: 768px) {
  .referance-logolist {
    padding: 0 42px;
    margin-bottom: 100px;
  }
}
@media only screen and (min-width: 1440px) {
  .referance-logolist {
    grid-template-columns: repeat(5, 1fr);
    padding: 0 42px;
    margin-bottom: 140px;
  }
}
.referance-logolist img {
  width: 75px;
  height: 75px;
  margin: auto;
  z-index: 3;
}
@media only screen and (min-width: 768px) {
  .referance-logolist img {
    width: 156px;
    height: 156px;
  }
}
@media only screen and (min-width: 1440px) {
  .referance-logolist img {
    width: 203px;
    height: 203px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/Referance.scss"],"names":[],"mappings":"AAEE;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AADJ;AAEI;EANF;IAOI,aAAA;IACA,yBAAA;EACJ;AACF;AAAI;EAVF;IAWI,aAAA;IACA,yBAAA;EAGJ;AACF;AAFI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAIN;AAFM;EAVF;IAWI,eAAA;IACA,iBAAA;EAKN;AACF;AAHM;EAfF;IAgBI,eAAA;IACA,iBAAA;EAMN;AACF;AAHI;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAKN;AAFI;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AAIN;AAFM;EANF;IAOI,YAAA;EAKN;AACF;AAHM;EAVF;IAWI,aAAA;EAMN;AACF;AAHI;EACE,aAAA;AAKN;AAFE;EACE,6DAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAIJ;AAHI;EARF;IASM,kBAAA;EAMN;AACF;AALI;EAXF;IAYI,wBAAA;IACE,kBAAA;EAQN;AACF;AAPI;EAfF;IAgBM,aAAA;EAUN;AACF;AARE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;AAUJ;AARI;EARF;IASI,eAAA;IACA,oBAAA;EAWJ;AACF;AATI;EAbF;IAcI,qCAAA;IACA,eAAA;IACA,oBAAA;EAYJ;AACF;AAVI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AAYN;AAXM;EALF;IAMI,YAAA;IACA,aAAA;EAcN;AACF;AAZM;EAVF;IAWI,YAAA;IACA,aAAA;EAeN;AACF","sourcesContent":[".referance {\n\n  &-header {\n    background-color: #FCAF17;\n    height: 360px;\n    position: relative;\n    z-index: 1;\n    padding: 0px 7% 30px 6%;\n    @media screen and (min-width: 415px) {\n      height: 370px;\n      padding: 0px 10% 45px 10%;\n    }\n    @media only screen and (min-width: 769px) {\n      height: 446px;\n      padding: 0px 15% 45px 15%;\n    }\n    &__text {\n      text-align: center;\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 36px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100%;\n\n      @media only screen and (min-width: 768px) {\n        font-size: 36px;\n        line-height: 120%;\n      }\n\n      @media only screen and (min-width: 1440px) {\n        font-size: 48px;\n        line-height: 62px;\n      }\n    }\n\n    .custom-shape-divider-bottom-1689675804 {\n      position: absolute;\n      bottom: -2px;\n      left: 0;\n      width: 100%;\n      overflow: hidden;\n      line-height: 0;\n    }\n    \n    .custom-shape-divider-bottom-1689675804 svg {\n      position: relative;\n      display: block;\n      width: calc(100% + 1.3px);\n      height: 23px;\n\n      @media only screen and (min-width: 768px) {\n        height: 31px;\n      }\n\n      @media only screen and (min-width: 1440px) {\n        height: 165px;\n      }\n    }\n    \n    .custom-shape-divider-bottom-1689675804 .shape-fill {\n      fill: #FFFFFF;\n    }\n  }\n  &-bg-image {\n    background: url(\"../../assets/images/Subtract-white.png\") no-repeat;\n    background-size: cover;\n    position: absolute;\n    z-index: 2;\n    height: 400px;\n    width: 100%;\n    margin-top: -176px;\n    @media screen and (max-width: 1440px) {\n        margin-top: -136px;\n    }\n    @media screen and (max-width: 1024px) {\n      background-size: contain;\n        margin-top: -125px;\n    }\n    @media screen and (max-width: 414px) {\n        display: none;\n    }\n  }\n  &-logolist {\n    position: relative;\n    padding: 0 30px;\n    margin-top: 20px;\n    margin-bottom: 36px;\n    grid-template-columns: repeat(4, 1fr);\n    display: grid;\n\n    @media only screen and (min-width: 768px) {\n      padding: 0 42px;\n      margin-bottom: 100px;\n    }\n\n    @media only screen and (min-width: 1440px) {\n      grid-template-columns: repeat(5, 1fr);\n      padding: 0 42px;\n      margin-bottom: 140px;\n    }\n\n    img {\n      width: 75px;\n      height: 75px;\n      margin: auto;\n      z-index: 3;\n      @media only screen and (min-width: 768px) {\n        width: 156px;\n        height: 156px;\n      }\n      \n      @media only screen and (min-width: 1440px) {\n        width: 203px;\n        height: 203px;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
